<template>
  <header
    class="header relative flex h-auto w-full flex-col landscape:rounded-xl bg-white dark:bg-gray-800 bg-clip-border p-4 text-gray-700 dark:text-gray-300 shadow-xl shadow-blue-gray-900/5 border border-blue-gray-800/10 dark:border-gray-700 transition-colors duration-300"
  >
    <!-- Header Content -->
    <div class="flex flex-wrap w-full justify-end items-center">
      <!-- Placeholder for Additional Content -->
      <div class="w-full flex-wrap flex">
        <p></p>
      </div>

      <!-- Action Buttons -->
      <div
        class="flex flex-row justify-center items-center self-end w-auto gap-2"
      >
        <button
          @click="toggleFullscreen"
          class="p-2 bg-white/80 dark:bg-gray-700/80 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600 transition-all duration-300"
          :title="isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'"
        >
          <svg
            v-if="!isFullscreen"
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-gray-700 dark:text-gray-200"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M8 3H5a2 2 0 00-2 2v3m0 8v3a2 2 0 002 2h3m8-18h3a2 2 0 012 2v3m0 8v3a2 2 0 01-2 2h-3"
            />
          </svg>

          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-gray-700 dark:text-gray-200"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 5l-7 7m0 0l7 7m-7-7h18"
            />
          </svg>
        </button>

        <!-- Boost Store Button --><!-- Boost Store Button -->
        <router-link
          to="/promotion"
          class="select-none boost-button rounded-lg border border-main-900 dark:border-gray-300 py-3 px-4 text-center align-middle text-xs font-semibold text-main-900 dark:text-gray-300 transition-all hover:opacity-75 active:opacity-[0.85] disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none gap-2 flex items-center"
          type="button"
        >
          <!-- Rocket Icon -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 text-main-900 dark:text-gray-300"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M15 2c0 4-1 6-3 8l2 2c2-2 4-3 8-3-1 5-4 8-8 8-1.5 0-3-.5-4.5-1.5L3 21l2.5-6.5C4 13 3.5 11.5 3.5 10c0-4 3-7 7-8h4z"
            />
          </svg>
          Boost Store
        </router-link>

        <!-- POS Button -->
        <router-link
          to="/pos"
          role="button"
          class="align-middle pos-button select-none font-semibold text-center transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-button dark:bg-sub-900 text-white dark:text-gray-200 shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-main-200 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none flex items-center gap-2"
          type="button"
        >
          <!-- Cash Register Icon -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 text-white dark:text-gray-200"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M4 6h16v2H4V6zm1 4h14v9a1 1 0 01-1 1H6a1 1 0 01-1-1v-9zm3 2v2h2v-2H8zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z"
            />
          </svg>
          POS
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "ClientHeader",
  data() {
    return {
      isFullscreen: false,
    };
  },
  methods: {
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      if (this.isFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {
          console.error(
            `Error attempting to enable fullscreen: ${err.message}`
          );
        });
      } else {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
      }
    },
  },
};
</script>
<style scoped>
.boost-button:hover {
  transform: translateY(-2px);
}
.pos-button:hover {
  transform: translateY(-2px);
}
</style>
